class BbdStickyAtc extends HTMLElement {
  connectedCallback() {
    this.submitButton = this.querySelector('[data-bbd-sticky-atc-submit]');
    this.buyBox = document.querySelector('product-form-component');

    if (this.submitButton) {
      this.submitButton.addEventListener('click', () => this.proxySubmit());
    }

    if (this.buyBox && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          const isBuyBoxVisible = entries.some((entry) => entry.isIntersecting);
          this.hidden = isBuyBoxVisible;
        },
        { rootMargin: '0px 0px -50% 0px' }
      );
      this.observer.observe(this.buyBox);
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  proxySubmit() {
    const realSubmitButton = document.querySelector(
      'product-form-component button[type="submit"][name="add"]'
    );

    if (realSubmitButton) {
      realSubmitButton.click();
    }
  }
}

if (!customElements.get('bbd-sticky-atc')) {
  customElements.define('bbd-sticky-atc', BbdStickyAtc);
}
